import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import QuickEdit from './quickEdit';
import ModelCard from '../components/ModelCard';
import CloseIcon from '@material-ui/icons/Close';

interface propTypes {
    featuredIndex: any;
    setfeaturedIndex(arg0: number);
    modelData: any;
    ListModels: any;
    editMode: any;
    removeButtClass: any;
    removeFromList: any;
    editForm: any;
    currentUser: any;
    visible: boolean;
}

// Handles normal model list view and edit view
export default function ListEdit(props: propTypes) {
    const { ListModels, editMode, removeButtClass, removeFromList, editForm, currentUser, visible } = props;

    const [currentDate, setCurrentDate] = useState(new Date().getTime());

    return (
        <Grid container spacing={6} className={`mb-[8vh] ${props.visible ? '' : '!hidden'}`} >
            {ListModels.map((card, index) => (
                <Grid item key={card.id} xs={12} sm={6} md={4} lg={3}>
                    {
                        editMode ?
                            <>
                                {/* Preview image */}
                                <div style={{ position: 'relative' }}>
                                    <a href={card.url} target="_blank">
                                        <img src={card.previewUrl + "?t=" + currentDate} className='w-full rounded' />
                                    </a>
                                    <IconButton size="small" className={removeButtClass} onChange={() => removeFromList(index)}> <CloseIcon /> </IconButton>
                                </div>

                                <QuickEdit
                                    modelIndex={index}
                                    editCB={editForm}
                                    model={props.modelData[index]}
                                    editable={currentUser && (currentUser.publicID == card.creator.username || currentUser.publicID == 'dook')}
                                    SelectedModel={index === props.featuredIndex}
                                    ChangeSelected={() => {
                                        if (index === props.featuredIndex)
                                            props.setfeaturedIndex(-1);
                                        else
                                            props.setfeaturedIndex(index);
                                    }}
                                />
                            </> :
                            <ModelCard
                                id={card.id}
                                title={card.title}
                                alt={card.alt}
                                creator={card.creator}
                                initials={card.creator.initials}
                                previewUrl={card.previewUrl}
                                url={card.url}
                            />
                    }
                </Grid>
            ))}
        </Grid>
    )
}